import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import querystring from 'querystring';
import { atomFamily, selectorFamily, SerializableParam } from 'recoil';
import axios from '../../common/axiosInterceptor';
import { Logger } from '../../common/Logger';
import { makePHPRequestPayload } from '../atoms/makePHPRequestPayload';
import { IUserAtom, user } from '../atoms/user';
export enum methodNameEnum {
  ADD_AGENT_TEAM = 'addAgentsTeam',
  ADD_EXTERNAL = 'submitExternalPrep',
  ADD_NEW_DISPOSIITON = 'submitNewDisposition',
  ADD_PORT = 'submitPortPrep',
  ADD_SPAM_LIKELY = 'manualAddSpamLikely',
  ADD_TEAM_QUEUE = 'addTeamQueue',
  BUY_PHONE_NUMBER = 'buyphonenumberany',
  CLOSE_DEAL_BY_BUSINESS_ID = 'closeDealByBusinessId',
  DECYPHER_PAYLOAD = 'decypherPayload',
  DELETE_CONFERENCE = 'deleteConference',
  DELETE_DEVICE = 'deleteDevice',
  DELETE_DISPOSITION = 'deleteDisposition',
  DELETE_GROUP = 'deleteGroup',
  DELETE_IVR = 'deleteIvr',
  DELETE_NUMBER = 'deleteNumber',
  DELETE_QUEUE = 'deleteQueue',
  DELETE_QUEUE_TEAM = 'deleteQueueTeam',
  DELETE_SMS_TEMPLATE = 'deleteSMSt',
  DELETE_TEAM = 'deleteTeam',
  DELETE_TEAM_MEMBER = 'deleteTeamMember',
  DELETE_VM_DROP = 'deleteVmd',
  DELETE_WEBHOOK = 'removeWebhook',
  EDIT_AGENT_PROFILE = 'webUpdateKixieUser',
  EDIT_CONFERENCE = 'editConference',
  EDIT_DEVICE = 'editDevice',
  EDIT_DISPOSITION = 'editDisposition',
  EDIT_NUMBER = 'editNumber',
  EDIT_NUMBER2 = 'editNumber2',
  FLUSH_USER_QUEUE = 'flushUserQueue',
  FORGOT_PASSWORD = 'forgotpassword',
  FTC_BLOCKING = 'updateFTCBlocking',
  GET_BILLING_STATUS = 'getbillingstatus',
  GET_BUSINESS_CONFERENCES = 'getBusinessConferences',
  GET_BUSINESS_DATA = 'getbusinessdata',
  GET_HAS_USERS_OAUTHED = 'getHasBusinessUserOauthed',
  GET_BUSINESS_DEVICES = 'getBusinessDevices',
  GET_BUSINESS_GROUPS = 'getBusinessGroups',
  GET_BUSINESS_IVRS = 'getBusinessIVRs',
  GET_BUSINESS_NUMBERS = 'getBusinessNumbers',
  GET_BUSINESS_NUMBERS_REPORTING = 'getBusinessNumbersReporting',
  GET_BUSINESS_PRODUCTS = 'getBusinessProducts',
  GET_BUSINESS_QUEUES = 'getBusinessQueues',
  GET_BUSINESS_SKILLS = 'getBusinessSkills',
  GET_BUSINESS_TEAMS = 'getBusinessTeams',
  GET_QUEUE_MEMBERS = 'getQueueMembers',
  GET_BUSINESS_USERS = 'getBusinessUsers',
  GET_BUSINESS_CRM_STATS = 'getBusinessCRMStats',
  GET_CUSTOM_CRM = 'getCustomCRM',
  GET_IVR_SETTINGS = 'getIVRSettings',
  GET_QUEUES_REPORTING = 'getQueuesReporting',
  GET_QUEUES_LIVE_REPORTING = 'getIncomingLiveQueueReportsByBusinessid',
  GET_QUEUE_TEAMS = 'getQueueTeams',
  GET_TEAM_SETTINGS = 'getTeamSettings',
  GET_USER_DISPOSITION_REPORTING = 'getUserDispositionReporting',
  GET_GROUP_RING_GROUP_SETTINGS = 'getGroupRingGroupSettings',
  GET_USER_RING_GROUP_SETTINGS = 'getUserRingGroupSettings',
  GET_WEBHOOKS = 'getWebhooks',
  INACTIVATE_AGENT = 'webUpdateKixieManagerDeleteUser',
  OTHERS_CAN_VIEW_RECORDINGS = 'updateOthersCanViewRecordings',
  PHONE_NUMBER_SEARCH = 'phonenumbersearch',
  REPLACE_USER = 'webUpdateKixieManagerReplaceUser',
  SUBMIT_IVR_MP3_FILE = 'submitIVRMp3File',
  SUBMIT_NEW_CONFERENCE = 'submitnewconference',
  SUBMIT_NEW_DEVICE = 'submitNewDevice',
  SUBMIT_NEW_GROUP = 'submitnewgroup',
  SUBMIT_NEW_IVR = 'submitnewivr',
  SUBMIT_NEW_KIXIE_DEVICE = 'submitNewKixieDevice',
  SUBMIT_NEW_QUEUE = 'submitnewqueue',
  SUBMIT_NEW_TEAM = 'submitnewteam',
  SUBMIT_NEW_TEMPLATE = 'submitNewSMSTemplate',
  SUBMIT_QUEUE_EDIT = 'submitQueueEdit',
  SUBMIT_QUEUE_GREETING_MP3_FILE = 'submitQueueGreetingMp3File',
  SUBMIT_QUEUE_HOLD_MUSIC_MP3_FILE = 'submitQueueRingAudioMp3File',
  SUBMIT_QUEUE_VOICEMAIL_MP3_FILE = 'submitQueueVoicemailMp3File',
  SUBMIT_RECORD_NOW_FILE = 'HandleAudioRecording',
  SUBMIT_RING_GROUP_SETTINGS = 'submitGroupRinggroup',
  SUBMIT_UPDATE_CARD = 'submitUpdateCard',
  SUBMIT_UPDATE_IVR = 'submitUpdateIVR',
  SUBMIT_USER_GREETING_MP3_FILE = 'submitUserGreetingMp3File',
  UPDATE_BUSINESS = 'updateBusiness',
  UPDATE_BUSINESS_SETTINGS = 'updateBusinessSettings',
  UPDATE_DEFAULT_DEVICE = 'updateDefaultDevice',
  UPDATE_IVR_EXTENSION_DIALING = 'updateIVR',
  UPDATE_LOCAL_PRESENCE = 'updateLPlite',
  UPDATE_MANAGEMENT_OPTIONS = 'webUpdateKixieManagerUser',
  UPDATE_QUEUE = 'updateQueue',
  UPDATE_RECHARGE = 'updateRecharge',
  UPDATE_SMS_TEMPLATE = 'updateSMSTemplate',
  UPDATE_SUPERADMIN_SETTINGS = 'updateSuperadminSettings',
  UPDATE_TEAM_NAME = 'updateTeam',
  UPDATE_USER = 'updateUser',
  UPDATE_USER_2 = 'updateUser2',
  UPDATE_USER_VOICEMAIL = 'updateUserVoicemail',
  WEB_UPDATE_KIXIE_USER_RING_GROUP = 'webUpdateKixieUserRingGroup',
  UPDATE_VM_DROP_NAME = 'updateVMDropName',
  GET_BUSINESS_DIDS = 'getBusinessDIDs',
  GET_VM_DROP = 'getvmdrop',
  GET_SMS_TEMPLATE = 'getAllsmstemplate',
  SEARCH_BUSINESS = 'searchBusiness',
  PUT_WEBHOOK = 'putWebhook',
  POST_WEBHOOK = 'postWebhook',
  GET_BUSINESS_ROUTING_RULES = 'getRoutingRulesByBusinessId',
  GET_ROUTING_RULE = 'getRoutingRuleById',
  DELETE_ROUTING_RULE = 'deleteRoutingRule',
  UPSERT_ROUTING_RULE = 'upsertRoutingRule',
  UPDATE_ROUTING_RULES_ORDER = 'updateRoutingRulesOrder',
  UPDATE_ROUTING_RULE_ACTIVE = 'updateRoutingRulesActive',
  UPDATE_BUSINESS_2 = 'updateBusiness2',
  UPDATE_BUSINESS_3 = 'updateBusiness3',
  UPDATE_BUSINESS_4 = 'updateBusiness4',
  GET_BUSINESS_SMS_BY_BUSINESS = 'getBusinessSMSByBusinessId',
  GET_10DLC_PROFILE_BRAND = 'get10DlcProfileBrand',
  UPDATE_10DLC_PROFILE = '10DlcProfileUpdate',
  GET_10DLC_CAMPAIGNS = 'get10DlcCampaigns',
  GET_10DLC_STATUS_MESSAGE = 'get10DlcStatusMessage',
  GET_USAGE_PLANS = 'getUsagePlans',
  GET_CALL_REVIEW = 'callReview',
  GET_NOTES_BY_BUSINESS = 'getNotesByBusiness',
  UPSERT_NOTE = 'upsertNote',
  UPDATE_NOTE_DISPLAY_ORDER = 'updateNoteDisplayOrder',
  ARCHIVE_NOTE = 'archiveNote',
  GET_NOTE_HISTORY = 'getNoteHistory',
  PROXY_HUBSPOT_VISITOR_IDENTIFICATION_API = 'proxyHubspotVisitorIdentificationAPI',
  GET_API_USAGE = 'getUsageReport',
  GET_USAGE_REPORTS_BY_BUSINESSID = 'getUsageReportByBusinessId',
  GET_SCHEDULED_REPORTS = 'getScheduledReports',
  GET_BUSINESS_SEGMENT = 'getBusinessSegment',
  GET_BUSINESS_SEGMENT_ES_DATA = 'getBusinessSegmentESData',
  GET_HELP_DESK_ARTICLES = 'getHelpDeskArticles',
  SEARCH_HELP_DESK_ARTICLES = 'searchHelpDeskArticles',
  GET_AUDIT_TRAIL = 'getAuditTrail',
  GET_AUDIT_EVENTS = 'getAuditEvents',
  REFUND_STRIPE_CHARGE_BY_CHARGE_ID = 'refundStripeChargeByChargeId',
}

/**
 * Atom used to control refetching of makePHPRequest
 * Toggle by changing true to false or false to true
 */
export const refetchToggle = atomFamily({
  key: 'refetchToggle',
  default: {
    // reset to empty object to refetch
  },
});

export interface IUserRecoil {
  userid?: string;
  businessid?: string;
  apikey?: string;
}

interface IMakePHPRequest
  extends Readonly<{ [key: string]: SerializableParam }> {
  /** Name of calling method (eg. GET_BUSINESS_IVRS) */
  methodName: string;
  /** Payload for immediate calls as JSON string (ie. will be parsed inside function) */
  payloadJsonString?: string;
  /** Set to true to stop initial ajax until payload atom set */
  waitForPayload?: boolean;
  /** Transaction id to break selector cache */
  transactionId?: string;
}

/**
 * Selector used to call PHP
 * NOTE: can return with null if user storage data has not been set
 *
 * @returns PHP response
 */
export const makePHPRequest = selectorFamily({
  key: 'makePHPRequest',
  get: ({
    methodName,
    payloadJsonString = '{}',
    waitForPayload = false,
    transactionId = '', // use this to break cache
  }: IMakePHPRequest) => async ({
    get, // add any to allow usage of recoil without the need to specify type
  }): Promise<AxiosResponse | AxiosError | undefined | any> => {
    const userStorage = get<IUserAtom | Record<string, unknown>>(
      user
    ) as IUserAtom;
    // subscribe so refresh-toggle
    get(refetchToggle(methodName));

    let payload;
    // conditionally subscribe
    if (waitForPayload) {
      payload = get<any>(makePHPRequestPayload(methodName));
    }

    // return undefined if user storage data is not set
    // or if not ready
    if ((waitForPayload && !payload) || !Object.keys(userStorage).length) {
      Logger.trace(
        {
          pathname: window.location.pathname,
          businessid: userStorage.businessid,
          apiKey: userStorage.apikey,
          userid: userStorage.user?.userid,
          methodName,
          message: 'Ajax not executed - payload empty or userStorage empty',
          waitForPayload,
          payload,
          userStorage: Object.keys(userStorage).length,
        },
        'makePHPRequest'
      );
      return;
    }

    let requestConfig: AxiosRequestConfig;
    // const accessToken = cookie.load('accessToken');

    // if payload is file then post using FormData
    if (payload?.file) {
      const data = new FormData();
      data.append('call', methodName);
      data.append('businessid', String(userStorage.businessid));
      data.append('apiKey', userStorage.apikey);
      data.append(payload.file.name, payload.file.content);
      Object.entries(payload?.payload ?? {}).forEach(
        ([key, value]: [string, any]) => {
          data.append(key, value);
        }
      );

      // if no payload then put body in query param for readability on network trace
      requestConfig = {
        method: 'post',
        url: `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php`,
        headers: {
          'content-type': 'multipart/form-data',
          // authorization: accessToken,
        },
        withCredentials: true,
        data,
      };
    } else {
      // otherwise post as normal
      requestConfig = {
        method: 'post',
        url: `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php`,
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          // authorization: accessToken,
        },
        data: querystring.stringify({
          call: methodName,
          businessid: userStorage.businessid,
          apiKey: userStorage.apikey,
          ...JSON.parse(payloadJsonString),
          ...payload,
        }),
        withCredentials: true,
      };
    }

    try {
      // validate user is populated first
      const response = await axios(requestConfig);

      if (
        (typeof response.data?.meta?.success === 'boolean' &&
          !response.data.meta.success) || // see if we can parse response and response has failure
        (typeof response.data?.error === 'string' && response.data?.error) // or error detected
      ) {
        Logger.error(
          {
            pathname: window.location.pathname,
            businessid: userStorage.businessid,
            apiKey: userStorage.apikey,
            userid: userStorage.user?.userid,
            methodName,
            requestConfig,
            response: response.data,
            exception: 'Error returned from ajax call',
          },
          'makePHPRequest'
        );
      } else {
        Logger.info(
          {
            pathname: window.location.pathname,
            businessid: userStorage.businessid,
            apiKey: userStorage.apikey,
            userid: userStorage.user?.userid,
            methodName,
            requestConfig,
            // response,
          },
          'makePHPRequest'
        );
      }
      // create new result for every request in order to
      // have useEffect dependency triggers work correctly
      return { ...response };
    } catch (exception) {
      Logger.error(
        {
          pathname: window.location.pathname,
          businessid: userStorage.businessid,
          apiKey: userStorage.apikey,
          userid: userStorage.user?.userid,
          methodName,
          requestConfig,
          exception,
        },
        'makePHPRequest'
      );
      return exception;
    }
  },
});
